import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { wentzvilleMOConfig } from "./data";

export default function WentzvilleMOPage() {
  return <CityPageTemplate config={wentzvilleMOConfig} />;
}